"use client";
import { IMG_URL } from "@/app/config";
import useFetch from "@/app/useFetch";
import React from "react";

const WhoisWho = () => {
  const { data: list = {}, loading, error } = useFetch(
    `/website/vigilance-who-is-who`,
    []
  );

  // Get all level keys sorted: ["1","2","3","4",...]
  const levels = Object.keys(list).sort((a, b) => Number(a) - Number(b));

  return (
    <section className="mt-40">
      <div className="org-chart">

        {levels.map((levelKey) => {
          const items = list[levelKey];

          return (
            <div
              key={levelKey}
              className={`level ${Number(levelKey) > 2 ? "multi" : ""}`}
            >
              {items?.map((item) => {
                const isLevel1 = levelKey === "1";

                const size = isLevel1
                  ? 180
                  : levelKey === "2"
                  ? 160
                  : 140; // Level 3+ sizes

                return (
                  <div
                    key={item.id}
                    className={isLevel1 ? "award-card who-director" : "card whocard"}
                  >
                    <div className={isLevel1 ? "award-img" : ""}>
                      <img
                        src={`${IMG_URL}${item.photo}`}
                        alt={item.name}
                        width={size}
                        height={size}
                      />
                    </div>

                    <div className={isLevel1 ? "award-content" : ""}>
                      <h4 className={isLevel1 ? "award-name" : ""}>{item.name}</h4>
                      <p className={isLevel1 ? "award-role" : ""}>
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WhoisWho;
